import { useQuery } from "@tanstack/react-query";
import useProductTypeApi from "apiClients/useProductTypeApiClient";
import { useLocaleStore } from "stores/localeStore";

export const PRODUCT_TYPES_QUERY_KEY = "product-types";
export const PRODUCT_TYPE_COVERAGE_QUERY_KEY = "product-type-coverage";

export const useProductTypesQuery = () => {
  const { getProductTypes } = useProductTypeApi();
  const { activeLanguage } = useLocaleStore();

  return useQuery({
    queryKey: [PRODUCT_TYPES_QUERY_KEY, activeLanguage?.locale],
    queryFn: getProductTypes,
  });
};

export const useProductTypeCoverageQuery = () => {
  const { getProductTypeCoverage } = useProductTypeApi();

  return useQuery({
    queryKey: [PRODUCT_TYPE_COVERAGE_QUERY_KEY],
    queryFn: getProductTypeCoverage,
  });
};
